import React, { useState } from 'react';
import './M3Chip.css';

/**
 * M3 Chip — four variants: assist, filter, input, suggestion.
 *
 * @param {'assist'|'filter'|'input'|'suggestion'} [variant='assist']
 * @param {boolean} [selected] — for filter/input chips
 * @param {boolean} [disabled]
 * @param {ReactNode} [icon] — leading icon
 * @param {ReactNode} [trailing] — trailing icon (e.g. close)
 * @param {Function} [onClick]
 */
export default function M3Chip({
  variant = 'assist',
  selected = false,
  disabled = false,
  icon,
  trailing,
  onClick,
  children,
  className = '',
  ...props
}) {
  const handleClick = () => {
    if (!disabled && onClick) onClick();
  };

  return (
    <button
      className={`m3-chip m3-chip-${variant} ${selected ? 'm3-chip-selected' : ''} ${
        disabled ? 'm3-chip-disabled' : ''
      } ${className}`}
      onClick={handleClick}
      disabled={disabled}
      role={variant === 'filter' || variant === 'input' ? 'checkbox' : undefined}
      aria-checked={selected ? 'true' : undefined}
      {...props}
    >
      {icon && <span className="m3-chip-icon">{icon}</span>}
      <span className="m3-chip-label">{children}</span>
      {trailing && <span className="m3-chip-trailing">{trailing}</span>}
    </button>
  );
}

/**
 * ChipGroup — renders multiple chips in a row with wrapping.
 */
export function ChipGroup({
  chips,
  variant = 'filter',
  selectedKeys = [],
  onToggle,
  className = ''
}) {
  return (
    <div className={`m3-chip-group ${className}`}>
      {chips.map((chip) => (
        <M3Chip
          key={chip.key}
          variant={variant}
          selected={selectedKeys.includes(chip.key)}
          onClick={() => onToggle?.(chip.key)}
          icon={chip.icon}
          trailing={chip.trailing}
          disabled={chip.disabled}
        >
          {chip.label}
        </M3Chip>
      ))}
    </div>
  );
}
